import axios from 'axios';
import ApiGateway from '../api.gateway';
import ApiService from '../api.services';

const ValuesPrepostService = {
  values: async function (params) {
    try {
      const res = await ApiService.post(`/api/values`, params);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  quotation: async function (params) {
    try {
      const res = await ApiGateway.post(`/gateway/values`, params);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  zipcode: async function (zipcode) {
    try {
      const res = await ApiGateway.get(`/gateway/values/${zipcode}`);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  upload: async function (customer, content) {
    try {
      const res = await ApiService.post(`/api/values/upload`, { customer, content });
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  check: function (data) {
    return axios.post(`/api/values/check`, data);
  },
  checkavailable: async function (list, source, destiny) {
    const request = [];
    for (const row of list) {
      request.push(this.check({ service: row.service.code, sourceZipcode: source, destinyZipcode: destiny }));
    }
    Promise.all(request).then(values => {
      return values;
    }).catch(error => {
      throw error;
    });
  },
};

export default ValuesPrepostService;

export { ValuesPrepostService };

